import { RouteRecordRaw } from 'vue-router';

const taskRoutes: Array<RouteRecordRaw> = [
  {
    path: 'tasks',
    component: () =>
      import('@/app/project-task/components/task-list/tasks-list-index.vue'),
    name: 'app.tasks',
  },
];

export default taskRoutes;
